import {isModuleBetaEnabled, toggleModuleBeta} from 'common/helpers'
import {FC, useCallback, useMemo} from 'react'
import {Button, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {ButtonVariant} from 'react-bootstrap/esm/types'
import {useIntl} from 'react-intl'
import {RouteObject, matchRoutes, useLocation} from 'react-router'

const BetaToggle: FC<{
  moduleKey: string
  color: ButtonVariant
  size?: 'sm' | 'lg'
  label?: string
  title?: string
  showOnRoutes?: RouteObject[]
}> = (props) => {
  const intl = useIntl()
  const location = useLocation()

  const matchedRoutes = props.showOnRoutes ? matchRoutes(props.showOnRoutes, location.pathname) : []

  const id = `${Math.random()}`

  const label =
    (props.label ?? isModuleBetaEnabled(props.moduleKey))
      ? 'GENERAL.TOGGLE_BETA_DISABLE'
      : 'GENERAL.TOGGLE_BETA_ENABLE'
  const labelHasTranslation = !!intl.messages[label]
  const titleHasTranslation = props.title ? !!intl.messages[props.title] : false

  const handleClick = useCallback(() => {
    toggleModuleBeta(props.moduleKey)
  }, [props.moduleKey])

  const renderTooltip = useMemo(() => {
    return (
      <Tooltip id={`tooltip-${id}`}>
        {titleHasTranslation ? intl.formatMessage({id: props.title}) : props.title}
      </Tooltip>
    )
  }, [props.title, id, intl, titleHasTranslation])

  const Btn = useMemo(
    () => (
      <Button id={id} variant={props.color} size={props.size} onClick={handleClick}>
        {labelHasTranslation ? intl.formatMessage({id: label}) : label}
      </Button>
    ),
    [handleClick, id, intl, labelHasTranslation, props.color, label, props.size]
  )

  if (!!props.showOnRoutes?.length && !matchedRoutes?.length) {
    return null
  }

  if (props.title) {
    return (
      <OverlayTrigger placement='auto' overlay={renderTooltip}>
        {Btn}
      </OverlayTrigger>
    )
  }

  return Btn
}

export default BetaToggle
